const getRandomInt = (max) => Math.floor(Math.random() * Math.floor(max))
export { getRandomInt }
